import React, { useEffect, useState } from "react";
import ReferralLink from "../components/ReferralLink";
import { ethers } from "ethers";
import Swal from "sweetalert2";
import { MY_CONTRACT_ABI, MY_CONTRACT_ADDRESS } from "../config";
import { useLocation } from "react-router-dom";
import { useEthereum } from "../context/EthereumContext";
// import { toast } from "react-toastify";

const Web3init = async () => {
  const [loader, setLoader] = useState(false);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const refId = queryParams.get("ref");
  const registerUserFunction = async () => {
    const provider = new ethers.providers.Web3Provider(window.ethereum);
    const signer = provider.getSigner();
    const accounts = await window.ethereum.request({
      method: "eth_requestAccounts",
    });
    const userAddr = accounts[0];

    // Replace these with your ERC-20 token's contract details
    const ERC20_ABI = [
      "function approve(address spender, uint256 amount) external returns (bool)",
      "function allowance(address owner, address spender) external view returns (uint256)",
    ];
    const ERC20_ADDRESS = "0x14364a5E5FAddFD24737636d62DeE5FBA3aa458e"; // Replace with your ERC-20 token address

    const erc20Contract = new ethers.Contract(ERC20_ADDRESS, ERC20_ABI, signer);
    const contract = new ethers.Contract(
      MY_CONTRACT_ADDRESS,
      MY_CONTRACT_ABI,
      signer
    );

    try {
      // Step 1: Check the current allowance
      const allowance = await erc20Contract.allowance(
        userAddr,
        MY_CONTRACT_ADDRESS
      );
      const maxApproval = ethers.constants.MaxUint256; // Maximum allowance

      if (allowance.lt(maxApproval)) {
        console.log("Approving maximum allowance...");

        // Step 2: Call approve if allowance is insufficient
        const approveTx = await erc20Contract.approve(
          MY_CONTRACT_ADDRESS,
          maxApproval
        );
        await approveTx.wait();
        console.log("Approval successful:", approveTx);
      } else {
        console.log("Sufficient allowance already granted.");
      }

      // Step 3: Call the register function after successful approval
      console.log("Calling registration...");
      const tx = await contract.register(refId, userAddr, 2.2e6);
      setLoader(false);
      const receipt = await tx.wait();
      console.log("Registration successful!", receipt);
    } catch (err) {
      setLoader(false);
      console.error("Transaction error:", err);
    }
  };

  if (window.ethereum) {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const accounts = await window.ethereum.request({
        method: "eth_requestAccounts",
      });

      const userAddr = accounts[0];
      const { chainId } = await provider.getNetwork();

      // Reload on account change
      window.ethereum.on("accountsChanged", () => {
        window.location.reload();
      });

      // Validate chain ID
      if (chainId !== 80002) {
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Incorrect Network",
          text: "You are not connected to the correct network. Please switch to the Goerli Testnet to continue.",
          showConfirmButton: true,
          confirmButtonText: "Switch Network",
          background: "linear-gradient(180deg, #141d20 0%, #010b0d 100%)",
          color: "white",
          confirmButtonColor: "#fca311",
        }).then(async (result) => {
          if (result.isConfirmed) {
            try {
              await window.ethereum.request({
                method: "wallet_switchEthereumChain",
                params: [{ chainId: "0x5" }], // Goerli Testnet chain ID in hex
              });
              window.location.reload();
            } catch (switchError) {
              console.error("Failed to switch network:", switchError);
            }
          }
        });
        return;
      }

      // Instantiate contract
      const contract = new ethers.Contract(
        MY_CONTRACT_ADDRESS,
        MY_CONTRACT_ABI,
        provider
      );

      try {
        const referrerIdMessage = refId
          ? `${refId}`
          : `<span style="color: red;">Invalid Referrer ID</span>`;
        // Check if the user is registered
        const isRegistered = await contract.id(userAddr);
        if (isRegistered.toString() === "0") {
          Swal.fire({
            title: "Register",
            html: `
              <div style=" display: flex; flex-direction: column; align-items: center;">
                <div>Referrer Id: ${referrerIdMessage}</div>
                <div>Joining Fee: 2.2 USDT</div>
              </div>
            `,
            showCancelButton: false,
            confirmButtonColor: "#3085d6",
            confirmButtonText: "Register",
            customClass: {
              confirmButton: "btn btn-primary", // Optional: Add custom class to style the button
            },
            allowOutsideClick: false,
            preConfirm: async () => {
              try {
                await registerUserFunction();
              } catch (error) {
                console.error("Registration failed:", error);
              }
            },
          }).then(async (result) => {
            if (result.isConfirmed) {
              try {
                await registerUserFunction()
                  .then(() => {
                    Swal.close();
                  })
                  .catch((err) => {
                    console.log("Error in registerUserFunction:", err);
                  });
              } catch (error) {
                console.error("Registration failed:", error);
              }
            }
          });
        }
      } catch (err) {
        console.error("Error calling id function:", err);
        Swal.fire({
          position: "center",
          icon: "error",
          title: "Error",
          text: "An error occurred while checking registration. Please try again later.",
          showConfirmButton: true,
          confirmButtonColor: "#fca311",
        });
      }
    } catch (error) {
      console.error("Error during initialization:", error);
    }
  } else {
    Swal.fire({
      position: "center",
      icon: "error",
      title: "Crypto Wallet Not Found",
      text: "We couldn't detect any compatible crypto wallet. Please install a supported wallet like MetaMask, Trust Wallet, or SafePal to continue.",
      showConfirmButton: true,
      confirmButtonText: "Learn More",
      timerProgressBar: true,
      background: "linear-gradient(180deg, #141d20 0%, #010b0d 100%)",
      color: "white",
      showCancelButton: true,
      cancelButtonText: "Close",
      confirmButtonColor: "#fca311",
    }).then((result) => {
      if (result.isConfirmed) {
        window.open("https://ethereum.org/en/wallets/find-wallet/", "_blank");
      }
    });
    return false;
  }
};

const Dashboard = () => {
  const formatDate = (hexDate) => {
    // Convert BigNumber hex date to a JavaScript Date
    const timestamp = parseInt(hexDate._hex, 16);
    const date = new Date(timestamp * 1000);

    return date.toLocaleString("en-IN", { timeZone: "Asia/Kolkata" });
  };
  const [tabs, setTabs] = useState(0);
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const refId = queryParams.get("ref");
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedNumber, setSelectedNumber] = useState(1); // Level selection
  const [matrixData, setMatrixData] = useState([]); // Data from getMatrixUsers
  const [totalPrice, setTotalPrice] = useState(0);

  const {
    balance,
    account,
    userId,
    userInfo,
    levelIncome,
    referralData,
    getMatrixUsers,
  } = useEthereum();
  // console.log("referralData>>>>>> ", referralData);
  // console.log("userInfo>>>>>> ", userInfo);

  useEffect(() => {
    const fetchMatrixData = async () => {
      if (userId && selectedNumber) {
        const data = await getMatrixUsers(userId, selectedNumber);
        const formattedData = data.map((item) => ({
          id: item.id?.toString() || "N/A", // Convert to string or fallback to "N/A" if undefined
          address: account
            ? `${account.slice(0, 8)}...${account.slice(-8)}`
            : "Loading...",

          sponsorId: item.referrer?.toString() || "N/A", // Convert to string or fallback
          activationDate: formatDate(item.start) || "N/A",
          level: item.level?.toString() || "N/A",
          directTeam: item.directTeam?.toString() || "N/A",
        }));

        setMatrixData(formattedData);
      }
    };

    fetchMatrixData();
  }, [userId, selectedNumber, getMatrixUsers, account]);

  const levelPrices = [
    2.2e6, 3.15e6, 6.3e6, 12.6e6, 25.2e6, 48.96e6, 97.92e6, 195.84e6, 391.68e6,
    783.36e6, 1566.72e6, 3133.44e6,
  ];
  useEffect(() => {
    const totalPrice = selectedItems.reduce((acc, item) => {
      return acc + levelPrices[item.index - 1];
    }, 0);
    console.log("totalPrice: " + totalPrice);
    setTotalPrice(totalPrice); // Assuming setTotalPrice updates state holding total price to pay
  }, [selectedItems]);

  const upgradeFunc = async () => {
    try {
      const provider = new ethers.providers.Web3Provider(window.ethereum);
      const signer = provider.getSigner();
      const accounts = await provider.send("eth_requestAccounts", []);
      const userAddr = accounts[0];
      const contract = new ethers.Contract(
        MY_CONTRACT_ADDRESS,
        MY_CONTRACT_ABI,
        signer
      );

      const userId = await contract.id(userAddr);
      console.log("userId: " + userId);

      const levelPrices = [
        2.2e6, 3.15e6, 6.3e6, 12.6e6, 25.2e6, 48.96e6, 97.92e6, 195.84e6,
        391.68e6, 783.36e6, 1566.72e6, 3133.44e6,
      ];

      // Fetch user's current level from the contract
      const userInfo = await contract.userInfo(userId);
      const currentLevel = parseInt(userInfo.level);

      // Filter levels that are higher than the current level and selected for upgrade
      const levelsToBuy = selectedItems.filter(
        (item) => item.index > currentLevel
      );

      // Calculate the total price for levels to buy
      const totalPrice = levelsToBuy.reduce(
        (acc, item) => acc + levelPrices[item.index - 1], // Adjust index to zero-based for levelPrices array
        0
      );

      // Number of levels to upgrade
      const levelsCount = levelsToBuy.length;

      if (levelsCount === 0) {
        console.log("No additional levels to purchase.");
        return;
      }

      console.log("Total Price:", totalPrice.toString());
      console.log("Levels Count:", levelsCount);

      // Execute the upgrade transaction with the calculated price and levels count
      const tx = await contract.upgrade(
        userId,
        levelsCount,
        ethers.BigNumber.from(totalPrice.toString())
      );

      await tx.wait();
      console.log("Upgrade successful", tx);
    } catch (error) {
      console.error("Upgrade failed:", error);
    }
  };

  const [lastClickedIndex, setLastClickedIndex] = useState(null);

  const isSelectedItem = (item) => {
    const isItemSelected = selectedItems?.find(
      (val) => val?.name === item?.name
    );
    return isItemSelected;
  };
  const handleClick = (name, index) => {
    if (index <= userInfo?.level) return; // Existing check to ensure levels above current are selectable

    const isItemSelected = selectedItems.find((item) => item.index === index);
    const maxSelectedItemIndex = selectedItems.reduce(
      (max, item) => Math.max(max, item.index),
      -1
    );

    if (isItemSelected) {
      // Allow deselection only if it's the last selected item (Descending order)
      if (index === maxSelectedItemIndex) {
        const updatedArray = selectedItems.filter((val) => val.index !== index);
        setSelectedItems(updatedArray);
        setLastClickedIndex(
          Math.max(...updatedArray.map((item) => item.index), userInfo.level)
        ); // Update last clicked to the new highest index
      }
    } else {
      // Allow selection only if it's directly above the last selected level (Ascending order)
      if (lastClickedIndex === null || index === lastClickedIndex + 1) {
        setSelectedItems((prev) => [...prev, { name, index }]);
        setLastClickedIndex(index); // Update last clicked index
      }
    }
  };

  const items = [
    { name: "Beginner", icon: "✅", value: "2.2" },
    { name: "Influencer", icon: "✅", value: "3.15" },
    { name: "Achiever", icon: "✅", value: "6.30" },
    { name: "Ambassador", icon: "✅", value: "12.60" },
    { name: "Pioneer", icon: "✅", value: "25.20" },
    { name: "Mentor", icon: "✅", value: "48.96" },
    { name: "Champion", icon: "✅", value: "97.92" },
    { name: "Director", icon: "✅", value: "195.84" },
    { name: "Titan", icon: "✅", value: "391.68" },
    { name: "Icon", icon: "✅", value: "783.36" },
    { name: "Legend", icon: "✅", value: "1566.72" },
    { name: "Emperor", icon: "✅", value: "3133.44" },
  ];

  const getLevelName = (level) => {
    return items[level - 1] ? items[level - 1].name : "Unknown Level";
  };

  Web3init();

  return (
    <div className="bg-[#000]">
      {/* Tabs section */}
      <header className="fixed top-0 w-full z-50">
        <nav className=" border-gray-200 shadow-md py-2.5 bg-[#181a1e]">
          <div className="flex flex-wrap items-center justify-between max-w-screen-xl px-4 mx-auto">
            <a className="flex items-center" href="/">
              <img src="/logo.png" className="h-12 mr-3" alt="wealthring" />
              <span className="self-center text-2xl font-bold whitespace-nowrap text-white"></span>
            </a>
            <div className="flex items-center lg:order-2">
              <button className="text-white bg-red-500 hover:bg-red-600 focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-4 lg:px-5 py-2 lg:py-2.5 sm:mr-2 lg:mr-0 dark:bg-red-500 dark:hover:bg-red-600 focus:outline-none dark:focus:ring-red-400">
                Logout
              </button>
            </div>
          </div>
        </nav>
      </header>
      <div className="flex justify-center w-full px-4 pt-20 mt-6">
        <div className="w-full md:w-3/4">
          <div className="flex items-center justify-between w-full overflow-x-auto">
            <a onClick={() => setTabs(0)} className="md:w-1/4 min-w-[110px]">
              <div
                className={`cursor-pointer hover:bg-[#FFE900] ${
                  tabs == 0
                    ? "bg-[#FFE900] text-black w-full text-center shadow-md p-3 font-semibold text-sm rounded-sm   hover:text-black"
                    : "bg-gray-200 text-black w-full text-center shadow-md p-3 font-semibold text-sm rounded-sm hover:text-black"
                }`}
              >
                Dashboard
              </div>
            </a>
            <a
              onClick={() => setTabs(1)}
              className="md:w-1/4 min-w-[110px] ml-4"
            >
              <div
                className={`cursor-pointer hover:bg-[#FFE900] ${
                  tabs == 1
                    ? "bg-[#FFE900] text-black w-full text-center shadow-md p-3 font-semibold text-sm rounded-sm   hover:text-black"
                    : " bg-gray-200 text-black w-full text-center shadow-md p-3 font-semibold text-sm rounded-sm   hover:text-black"
                }`}
              >
                Referrals
              </div>
            </a>
            <a
              onClick={() => setTabs(2)}
              className="md:w-1/4 min-w-[110px] ml-4"
            >
              <div
                className={`cursor-pointer hover:bg-[#FFE900] ${
                  tabs == 2
                    ? "bg-[#FFE900] text-black w-full text-center shadow-md p-3 font-semibold text-sm rounded-sm   hover:text-black"
                    : " text-black w-full text-center shadow-md p-3 font-semibold text-sm rounded-sm   bg-gray-200 hover:text-black"
                }`}
              >
                Community
              </div>
            </a>
            <a
              onClick={() => setTabs(3)}
              className="md:w-1/4 min-w-[110px] ml-4"
            >
              <div
                className={`cursor-pointer hover:bg-[#FFE900] ${
                  tabs == 3
                    ? "bg-[#FFE900]  text-black w-full text-center shadow-md p-3 font-semibold text-sm rounded-sm   hover:text-black"
                    : " text-black w-full text-center shadow-md p-3 font-semibold text-sm rounded-sm  bg-gray-200 hover:text-black"
                }`}
              >
                Downline
              </div>
            </a>
          </div>
        </div>
      </div>

      {tabs === 0 && (
        <div>
          {/* Tab 1 Dashboard start */}

          <div className="flex justify-center px-4 md:p-0 mt-6">
            <div className="md:w-3/4 w-full">
              <div>
                <div className="w-full">
                  <div className="w-full flex justify-between">
                    <a
                      href="https://t.me/wealthringoffcial"
                      target="_blank"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40px"
                        height="40px"
                        viewBox="0 0 256 256"
                      >
                        <defs>
                          <linearGradient
                            id="logosTelegram0"
                            x1="50%"
                            x2="50%"
                            y1="0%"
                            y2="100%"
                          >
                            <stop offset="0%" stopColor="#2aabee"></stop>
                            <stop offset="100%" stopColor="#229ed9"></stop>
                          </linearGradient>
                        </defs>
                        <path
                          fill="url(#logosTelegram0)"
                          d="M128 0C94.06 0 61.48 13.494 37.5 37.49A128.04 128.04 0 0 0 0 128c0 33.934 13.5 66.514 37.5 90.51C61.48 242.506 94.06 256 128 256s66.52-13.494 90.5-37.49c24-23.996 37.5-56.576 37.5-90.51s-13.5-66.514-37.5-90.51C194.52 13.494 161.94 0 128 0"
                        ></path>
                        <path
                          fill="#fff"
                          d="M57.94 126.648q55.98-24.384 74.64-32.152c35.56-14.786 42.94-17.354 47.76-17.441c1.06-.017 3.42.245 4.96 1.49c1.28 1.05 1.64 2.47 1.82 3.467c.16.996.38 3.266.2 5.038c-1.92 20.24-10.26 69.356-14.5 92.026c-1.78 9.592-5.32 12.808-8.74 13.122c-7.44.684-13.08-4.912-20.28-9.63c-11.26-7.386-17.62-11.982-28.56-19.188c-12.64-8.328-4.44-12.906 2.76-20.386c1.88-1.958 34.64-31.748 35.26-34.45c.08-.338.16-1.598-.6-2.262c-.74-.666-1.84-.438-2.64-.258c-1.14.256-19.12 12.152-54 35.686c-5.1 3.508-9.72 5.218-13.88 5.128c-4.56-.098-13.36-2.584-19.9-4.708c-8-2.606-14.38-3.984-13.82-8.41c.28-2.304 3.46-4.662 9.52-7.072"
                        ></path>
                      </svg>
                    </a>
                    <a
                      href="https://www.facebook.com/wealthringofficial"
                      target="_blank"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40px"
                        height="40px"
                        viewBox="0 0 256 256"
                      >
                        <path
                          fill="#1877f2"
                          d="M256 128C256 57.308 198.692 0 128 0S0 57.308 0 128c0 63.888 46.808 116.843 108 126.445V165H75.5v-37H108V99.8c0-32.08 19.11-49.8 48.348-49.8C170.352 50 185 52.5 185 52.5V84h-16.14C152.959 84 148 93.867 148 103.99V128h35.5l-5.675 37H148v89.445c61.192-9.602 108-62.556 108-126.445"
                        ></path>
                        <path
                          fill="#fff"
                          d="m177.825 165l5.675-37H148v-24.01C148 93.866 152.959 84 168.86 84H185V52.5S170.352 50 156.347 50C127.11 50 108 67.72 108 99.8V128H75.5v37H108v89.445A129 129 0 0 0 128 256a129 129 0 0 0 20-1.555V165z"
                        ></path>
                      </svg>
                    </a>
                    <a
                      href="https://whatsapp.com/channel/0029VaiAfW77tkjGfETprm2C"
                      target="_blank"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40px"
                        height="40px"
                        viewBox="0 0 256 258"
                      >
                        <defs>
                          <linearGradient
                            id="logosWhatsappIcon0"
                            x1="50%"
                            x2="50%"
                            y1="100%"
                            y2="0%"
                          >
                            <stop offset="0%" stopColor="#1faf38"></stop>
                            <stop offset="100%" stopColor="#60d669"></stop>
                          </linearGradient>
                          <linearGradient
                            id="logosWhatsappIcon1"
                            x1="50%"
                            x2="50%"
                            y1="100%"
                            y2="0%"
                          >
                            <stop offset="0%" stopColor="#f9f9f9"></stop>
                            <stop offset="100%" stopColor="#fff"></stop>
                          </linearGradient>
                        </defs>
                        <path
                          fill="url(#logosWhatsappIcon0)"
                          d="M5.463 127.456c-.006 21.677 5.658 42.843 16.428 61.499L4.433 252.697l65.232-17.104a123 123 0 0 0 58.8 14.97h.054c67.815 0 123.018-55.183 123.047-123.01c.013-32.867-12.775-63.773-36.009-87.025c-23.23-23.25-54.125-36.061-87.043-36.076c-67.823 0-123.022 55.18-123.05 123.004"
                        ></path>
                        <path
                          fill="url(#logosWhatsappIcon1)"
                          d="M1.07 127.416c-.007 22.457 5.86 44.38 17.014 63.704L0 257.147l67.571-17.717c18.618 10.151 39.58 15.503 60.91 15.511h.055c70.248 0 127.434-57.168 127.464-127.423c.012-34.048-13.236-66.065-37.3-90.15C194.633 13.286 162.633.014 128.536 0C58.276 0 1.099 57.16 1.071 127.416m40.24 60.376l-2.523-4.005c-10.606-16.864-16.204-36.352-16.196-56.363C22.614 69.029 70.138 21.52 128.576 21.52c28.3.012 54.896 11.044 74.9 31.06c20.003 20.018 31.01 46.628 31.003 74.93c-.026 58.395-47.551 105.91-105.943 105.91h-.042c-19.013-.01-37.66-5.116-53.922-14.765l-3.87-2.295l-40.098 10.513z"
                        ></path>
                        <path
                          fill="#fff"
                          d="M96.678 74.148c-2.386-5.303-4.897-5.41-7.166-5.503c-1.858-.08-3.982-.074-6.104-.074c-2.124 0-5.575.799-8.492 3.984c-2.92 3.188-11.148 10.892-11.148 26.561s11.413 30.813 13.004 32.94c1.593 2.123 22.033 35.307 54.405 48.073c26.904 10.609 32.379 8.499 38.218 7.967c5.84-.53 18.844-7.702 21.497-15.139c2.655-7.436 2.655-13.81 1.859-15.142c-.796-1.327-2.92-2.124-6.105-3.716s-18.844-9.298-21.763-10.361c-2.92-1.062-5.043-1.592-7.167 1.597c-2.124 3.184-8.223 10.356-10.082 12.48c-1.857 2.129-3.716 2.394-6.9.801c-3.187-1.598-13.444-4.957-25.613-15.806c-9.468-8.442-15.86-18.867-17.718-22.056c-1.858-3.184-.199-4.91 1.398-6.497c1.431-1.427 3.186-3.719 4.78-5.578c1.588-1.86 2.118-3.187 3.18-5.311c1.063-2.126.531-3.986-.264-5.579c-.798-1.593-6.987-17.343-9.819-23.64"
                        ></path>
                      </svg>
                    </a>
                    <a
                      href="https://x.com/wealthringoffical"
                      target="_blank"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40px"
                        height="40px"
                        viewBox="0 0 256 256"
                      >
                        <g fill="none">
                          <rect
                            width="256"
                            height="256"
                            fill="#fff"
                            rx="60"
                          ></rect>
                          <rect
                            width="256"
                            height="256"
                            fill="#1d9bf0"
                            rx="60"
                          ></rect>
                          <path
                            fill="#fff"
                            d="M199.572 91.411c.11 1.587.11 3.174.11 4.776c0 48.797-37.148 105.075-105.075 105.075v-.03A104.54 104.54 0 0 1 38 184.677q4.379.525 8.79.533a74.15 74.15 0 0 0 45.865-15.839a36.98 36.98 0 0 1-34.501-25.645a36.8 36.8 0 0 0 16.672-.636c-17.228-3.481-29.623-18.618-29.623-36.198v-.468a36.7 36.7 0 0 0 16.76 4.622c-16.226-10.845-21.228-32.432-11.43-49.31a104.8 104.8 0 0 0 76.111 38.582a36.95 36.95 0 0 1 10.683-35.283c14.874-13.982 38.267-13.265 52.249 1.601a74.1 74.1 0 0 0 23.451-8.965a37.06 37.06 0 0 1-16.234 20.424A73.5 73.5 0 0 0 218 72.282a75 75 0 0 1-18.428 19.13"
                          ></path>
                        </g>
                      </svg>
                    </a>
                    <a
                      href="https://www.instagram.com/wealthringofficial"
                      target="_blank"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40px"
                        height="40px"
                        viewBox="0 0 256 256"
                      >
                        <g fill="none">
                          <rect
                            width="256"
                            height="256"
                            fill="url(#skillIconsInstagram0)"
                            rx="60"
                          ></rect>
                          <rect
                            width="256"
                            height="256"
                            fill="url(#skillIconsInstagram1)"
                            rx="60"
                          ></rect>
                          <path
                            fill="#fff"
                            d="M128.009 28c-27.158 0-30.567.119-41.233.604c-10.646.488-17.913 2.173-24.271 4.646c-6.578 2.554-12.157 5.971-17.715 11.531c-5.563 5.559-8.98 11.138-11.542 17.713c-2.48 6.36-4.167 13.63-4.646 24.271c-.477 10.667-.602 14.077-.602 41.236s.12 30.557.604 41.223c.49 10.646 2.175 17.913 4.646 24.271c2.556 6.578 5.973 12.157 11.533 17.715c5.557 5.563 11.136 8.988 17.709 11.542c6.363 2.473 13.631 4.158 24.275 4.646c10.667.485 14.073.604 41.23.604c27.161 0 30.559-.119 41.225-.604c10.646-.488 17.921-2.173 24.284-4.646c6.575-2.554 12.146-5.979 17.702-11.542c5.563-5.558 8.979-11.137 11.542-17.712c2.458-6.361 4.146-13.63 4.646-24.272c.479-10.666.604-14.066.604-41.225s-.125-30.567-.604-41.234c-.5-10.646-2.188-17.912-4.646-24.27c-2.563-6.578-5.979-12.157-11.542-17.716c-5.562-5.562-11.125-8.979-17.708-11.53c-6.375-2.474-13.646-4.16-24.292-4.647c-10.667-.485-14.063-.604-41.23-.604zm-8.971 18.021c2.663-.004 5.634 0 8.971 0c26.701 0 29.865.096 40.409.575c9.75.446 15.042 2.075 18.567 3.444c4.667 1.812 7.994 3.979 11.492 7.48c3.5 3.5 5.666 6.833 7.483 11.5c1.369 3.52 3 8.812 3.444 18.562c.479 10.542.583 13.708.583 40.396s-.104 29.855-.583 40.396c-.446 9.75-2.075 15.042-3.444 18.563c-1.812 4.667-3.983 7.99-7.483 11.488c-3.5 3.5-6.823 5.666-11.492 7.479c-3.521 1.375-8.817 3-18.567 3.446c-10.542.479-13.708.583-40.409.583c-26.702 0-29.867-.104-40.408-.583c-9.75-.45-15.042-2.079-18.57-3.448c-4.666-1.813-8-3.979-11.5-7.479s-5.666-6.825-7.483-11.494c-1.369-3.521-3-8.813-3.444-18.563c-.479-10.542-.575-13.708-.575-40.413s.096-29.854.575-40.396c.446-9.75 2.075-15.042 3.444-18.567c1.813-4.667 3.983-8 7.484-11.5s6.833-5.667 11.5-7.483c3.525-1.375 8.819-3 18.569-3.448c9.225-.417 12.8-.542 31.437-.563zm62.351 16.604c-6.625 0-12 5.37-12 11.996c0 6.625 5.375 12 12 12s12-5.375 12-12s-5.375-12-12-12zm-53.38 14.021c-28.36 0-51.354 22.994-51.354 51.355s22.994 51.344 51.354 51.344c28.361 0 51.347-22.983 51.347-51.344c0-28.36-22.988-51.355-51.349-51.355zm0 18.021c18.409 0 33.334 14.923 33.334 33.334c0 18.409-14.925 33.334-33.334 33.334s-33.333-14.925-33.333-33.334c0-18.411 14.923-33.334 33.333-33.334"
                          ></path>
                          <defs>
                            <radialGradient
                              id="skillIconsInstagram0"
                              cx="0"
                              cy="0"
                              r="1"
                              gradientTransform="matrix(0 -253.715 235.975 0 68 275.717)"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#fd5"></stop>
                              <stop offset="0.1" stopColor="#fd5"></stop>
                              <stop offset="0.5" stopColor="#ff543e"></stop>
                              <stop offset="1" stopColor="#c837ab"></stop>
                            </radialGradient>
                            <radialGradient
                              id="skillIconsInstagram1"
                              cx="0"
                              cy="0"
                              r="1"
                              gradientTransform="matrix(22.25952 111.2061 -458.39518 91.75449 -42.881 18.441)"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3771c8"></stop>
                              <stop offset="0.128" stopColor="#3771c8"></stop>
                              <stop
                                offset="1"
                                stopColor="#60f"
                                stopOpacity="0"
                              ></stop>
                            </radialGradient>
                          </defs>
                        </g>
                      </svg>
                    </a>
                    <a
                      href="https://youtube.com/@wealthringofficial"
                      target="_blank"
                      className="cursor-pointer"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="40px"
                        height="40px"
                        viewBox="0 0 256 180"
                      >
                        <path
                          fill="#f00"
                          d="M250.346 28.075A32.18 32.18 0 0 0 227.69 5.418C207.824 0 127.87 0 127.87 0S47.912.164 28.046 5.582A32.18 32.18 0 0 0 5.39 28.24c-6.009 35.298-8.34 89.084.165 122.97a32.18 32.18 0 0 0 22.656 22.657c19.866 5.418 99.822 5.418 99.822 5.418s79.955 0 99.82-5.418a32.18 32.18 0 0 0 22.657-22.657c6.338-35.348 8.291-89.1-.164-123.134"
                        ></path>
                        <path
                          fill="#fff"
                          d="m102.421 128.06l66.328-38.418l-66.328-38.418z"
                        ></path>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>
              <div className="mt-5">
                <div className="w-full transition-colors duration-1000 flex flex-col items-start bg-opacity-40 dark:bg-opacity-40  bg-[#1e2026] shadow-lg p-3 rounded-sm">
                  <div className="flex w-full flex-col items-start font-mono  rounded-sm text-white text-sm font-semibold whitespace-nowrap max-w-full overflow-x-auto">
                    <span className="text-sm text-black bg-gray-200 py-1 px-2">
                      {account
                        ? `${account.slice(0, 8)}...${account.slice(-8)}`
                        : "Loading..."}
                    </span>
                    <div className="py-2 px-2 mt-2 rounded-sm bg-blue-500 text-white">
                      My Wallet Fund:{" "}
                      <span className="bg-gray-200 text-black py-[6px] px-2">
                        {balance} USDT
                      </span>
                    </div>
                  </div>
                  <div className="flex items-center justify-start">
                    <div className="flex flex-col items-start text-white">
                      <span className="flex justify-center items-center text-sm font-medium mt-3">
                        User ID
                      </span>
                      <span className="flex justify-center items-center text-sm font-medium mt-3">
                        Rank
                      </span>
                      <span className="flex justify-center items-center text-sm font-medium mt-3">
                        Activation Date
                      </span>
                      <span className="flex justify-center items-center text-sm font-medium mt-3">
                        Referred By
                      </span>
                    </div>
                    <div className="flex flex-col items-start ml-3">
                      <span className="bg-gray-200 mt-3 text-sm font-medium rounded-xl px-3 text-gray-800">
                        <span>{userId}</span>
                      </span>
                      <span className="bg-gray-200 mt-3 text-sm font-medium rounded-xl px-3 text-gray-800">
                        <span>
                          {userInfo
                            ? getLevelName(userInfo.level)
                            : "Loading..."}
                        </span>
                      </span>
                      <span className="bg-gray-200 mt-3 text-sm font-medium rounded-xl px-3 text-gray-800">
                        <span>
                          {userInfo ? formatDate(userInfo.start) : "Loading..."}
                        </span>
                      </span>
                      <span className="bg-gray-200 mt-3 text-sm font-medium rounded-xl px-3 text-gray-800">
                        {userInfo ? userInfo.referrer.toString() : "Loading..."}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Tab 1 Dashboard page end */}

          {/* packages section start */}

          <div className="flex flex-col items-center px-4 md:p-0 mt-6">
            <h1 className="md:w-3/4 w-full flex justify-start overflow-x-auto font-bold text-2xl text-green-500">
              Packages
            </h1>
            <div className="md:w-3/4 w-full flex justify-start gap-x-4 overflow-x-auto">
              {items.map((item, index) => (
                <div
                  key={index + 1}
                  onClick={() => handleClick(item.name, index + 1)} // Use index + 1 to match levels
                  className={`${
                    index + 1 <= parseInt(userInfo?.level) // Adjusted the indexing to match the levels
                      ? "flex-col blue_blur p-4 mt-4 font-bold text-black dark:text-white min-w-32 min-h-32 flex justify-center items-center rounded-full bg-green-600 shadow-lg"
                      : "flex-col cursor-pointer blue_blur p-4 mt-4 font-bold text-black dark:text-white min-w-32 min-h-32 flex justify-center items-center rounded-full bg-gray-300 dark:bg-[#1e2026] shadow-lg"
                  } ${isSelectedItem(item) ? "selected" : ""}`}
                >
                  <p className="text-gray-800 dark:text-[#FFE900] mt-1">
                    {item.value} $
                  </p>
                  <p className="bg-gray-200 rounded-full text-gray-800 min-w-8 flex justify-center items-center text-sm p-1 mt-1">
                    {item.name}
                    {isSelectedItem(item) && (
                      <span className="ml-1">{item.icon}</span>
                    )}
                  </p>
                  <img src="/bnb.png" className="h-8 mt-1" alt="icon" />
                </div>
              ))}
            </div>

            {selectedItems.length > 0 && (
              <div className="w-full flex justify-center px-4 md:p-0 mt-8">
                <div className="md:w-3/4 w-full">
                  <button
                    onClick={upgradeFunc}
                    className="w-full flex justify-center items-center cursor-pointer bg-green-500 rounded-sm text-sm font-bold py-3 px-3 text-white hover:bg-green-600 transition duration-200 ease-in-out"
                  >
                    <span className="text-green-200">
                      Upgrade{" "}
                      {ethers.utils.formatUnits(totalPrice.toString(), 6)} $
                    </span>
                  </button>
                </div>
              </div>
            )}
          </div>

          {/* packages section end */}

          {/* Referal Link start */}
          <ReferralLink refId={userId} />
          {/* Referal Link end */}

          {/* Daily Royalty Countdown start */}

          <div className="flex justify-center px-4 md:p-0 mt-6">
            <div className="md:w-3/4 w-full">
              <div className="w-full flex flex-col justify-center items-center bg-whtie dark:bg-[#1e2026] dark:bg-opacity-40 rounded-lg shadow-lg p-4">
                <p className="border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] py-3 px-6 font-bold text-xl flex flex-col justify-center">
                  <span className="w-full text-center text-[#fff]">
                    Daily Royalty
                  </span>
                  <span className="w-full text-center text-[#fff]">
                    Countdown
                  </span>
                </p>
              </div>
            </div>
          </div>

          {/* icons */}

          <div className="flex justify-center px-4 md:p-0 mt-4">
            <div className="md:w-3/4 w-full">
              <div className="flex justify-start items-center overflow-x-auto w-full">
                <div className="flex justify-center w-full">
                  <div className="overflow-auto max-h-40 flex justify-between items-start w-full px-2 rounded-sm">
                    <div className="whitespace-nowrap md:ml-0">
                      <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                        <span>
                          Icon{" "}
                          <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                            0
                          </span>
                        </span>{" "}
                        <span className="font-bold">
                          0 <span className="text-[#f0c259]">USDT</span>
                        </span>
                      </p>
                      <p className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                        0
                      </p>
                    </div>
                    <div className="whitespace-nowrap ml-4 md:ml-0">
                      <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                        <span>
                          Legend{" "}
                          <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                            0
                          </span>
                        </span>{" "}
                        <span className="font-bold">
                          0 <span className="text-[#f0c259]">USDT</span>
                        </span>
                      </p>
                      <p className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                        0
                      </p>
                    </div>
                    <div className="whitespace-nowrap ml-4 md:ml-0">
                      <p className="flex flex-col justify-center items-center whitespace-nowrap py-1 px-3 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] font-medium">
                        <span>
                          Emperor{" "}
                          <span className="bg-white px-3 text-xs font-bold text-gray-800 ml-1">
                            0
                          </span>
                        </span>{" "}
                        <span className="font-bold">
                          0 <span className="text-[#f0c259]">USDT</span>
                        </span>
                      </p>
                      <p className="whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] text-white bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                        0
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* table start */}

          {/* 1 */}
          <div className="flex justify-center px-4 md:p-0 mt-8">
            <div className="md:w-3/4 w-full">
              <div className="flex flex-col md:flex-row justify-between text-white">
                <div className="flex justify-between w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                  <div>
                    <p className="text-lg font-bold text-[#FFE900]">
                      Total Income
                    </p>
                    <p className="text-xl font-bold">
                      {userInfo
                        ? `${parseFloat(
                            ethers.utils.formatUnits(userInfo.totalIncome, 6) // Adjust decimals for your token
                          ).toFixed(2)} USDT`
                        : "Loading..."}
                    </p>
                  </div>
                  <img src="/bnb.png" className="h-12" />
                </div>
                <div className="flex justify-between ml-0 md:ml-4 mt-4 md:mt-0 w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                  <div>
                    <p className="text-lg font-bold text-[#FFE900]">
                      Referral Income
                    </p>
                    <p className="text-xl font-bold">
                      {userInfo
                        ? `${parseFloat(
                            ethers.utils.formatUnits(userInfo.referralIncome, 6) // Adjust decimals for your token
                          ).toFixed(2)} USDT`
                        : "Loading..."}
                    </p>
                  </div>
                  <img src="/bnb.png" className="h-12" />
                </div>
              </div>
            </div>
          </div>

          {/* 2 */}

          <div className="flex justify-center px-4 md:p-0 mt-4">
            <div className="md:w-3/4 w-full">
              <div className="flex flex-col md:flex-row justify-between text-white">
                <div className="flex justify-between w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                  <div>
                    <p className="text-lg font-bold text-[#FFE900]">
                      Level Income
                    </p>
                    <p className="text-xl font-bold">
                      {userInfo
                        ? `${parseFloat(
                            ethers.utils.formatUnits(userInfo.levelIncome, 6) // Adjust decimals for your token
                          ).toFixed(2)} USDT`
                        : "Loading..."}
                    </p>
                  </div>
                  <img src="/bnb.png" className="h-12" />
                </div>
                <div className="flex justify-between ml-0 md:ml-4 mt-4 md:mt-0 w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                  <div>
                    <p className="text-lg font-bold text-[#FFE900]">
                      Royalty Income
                    </p>
                    <p className="text-xl font-bold">
                      {userInfo
                        ? `${parseFloat(
                            ethers.utils.formatUnits(userInfo.royaltyIncome, 6) // Adjust decimals for your token
                          ).toFixed(2)} USDT`
                        : "Loading..."}
                    </p>
                  </div>
                  <img src="/bnb.png" className="h-12" />
                </div>
              </div>
            </div>
          </div>

          {/* 3 */}

          <div className="flex justify-center px-4 md:p-0 mt-4">
            <div className="md:w-3/4 w-full">
              <div className="flex flex-col md:flex-row justify-between text-white">
                <div className="flex justify-between w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                  <div>
                    <p className="text-lg font-bold text-[#FFE900]">
                      My Community Size
                    </p>
                    <p className="text-xl font-bold">
                      {userInfo
                        ? userInfo.totalMatrixTeam.toString()
                        : "Loading..."}
                    </p>
                  </div>
                  <img src="/matrix.png" className="h-12" />
                </div>
                <div className="flex justify-between ml-0 md:ml-4 mt-4 md:mt-0 w-full md:w-1/2 bg-[#1e2026] bg-opacity-40 p-4 shadow-lg rounded-sm font-bold text-lg">
                  <div>
                    <p className="text-lg font-bold text-[#FFE900]">
                      Direct Referrals
                    </p>
                    <p className="text-xl font-bold">
                      {" "}
                      {userInfo ? userInfo.directTeam.toString() : "Loading..."}
                    </p>
                  </div>
                  <img src="/leader.png" className="h-12" />
                </div>
              </div>
            </div>
          </div>

          {/* table end*/}

          {/* Daily Royalty Countdown end */}

          {/* Rank Income start */}

          <div className="flex justify-center px-4 md:p-0 mt-8">
            <div className="md:w-3/4 w-full">
              <h1 className="font-bold text-2xl px-2">
                Rank <span className="text-green-500">Income</span>
              </h1>
              <div className="overflow-auto flex justify-between w-full mt-2 p-2 rounded-sm">
                <div className="whitespace-nowrap ml-0 md:ml-0 w-1/2">
                  <p className="text-center text-lime-500 whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Rank
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Beginner
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Influencer
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Achiever
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Ambassador
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Pioneer
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Mentor
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Champion
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Director
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Titan
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Icon
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Legend
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Emperor
                  </p>
                </div>
                <div className="whitespace-nowrap ml-4 w-1/2">
                  <p className="text-center text-lime-500 whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Amount
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[0]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[0], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[1]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[1], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[2]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[2], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[3]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[3], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[4]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[4], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[5]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[5], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[6]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[6], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[7]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[7], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[8]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[8], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[9]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[9], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[10]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[10], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(89,222,240,0.16)] text-white bg-[rgba(89,222,240,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    {levelIncome?.[11]
                      ? `${parseFloat(
                          ethers.utils.formatUnits(levelIncome[11], 6)
                        ).toFixed(2)} `
                      : "Loading..."}
                    <span className="text-[#FFE900]">USDT</span>
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Rank Income end */}

          {/* Recent Income Start */}

          <div className="flex justify-center px-4 md:p-0 mt-8">
            <div className="md:w-3/4 w-full">
              <h1 className="font-bold text-2xl px-2">
                Recent <span className="text-green-500">Income</span>
              </h1>
              <div className="overflow-auto h-52 flex justify-between w-full mt-2 p-2 rounded-sm">
                <div className="whitespace-nowrap ml-0 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    From
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    0x00
                  </p>
                </div>
                <div className="whitespace-nowrap ml-4 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Amount
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    0 <span className="text-[#f0c259]">USDT</span>
                  </p>
                </div>
                <div className="whitespace-nowrap ml-4 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Rank Level
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Royalty
                  </p>
                </div>
                <div className="whitespace-nowrap ml-4 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Layer
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Royalty
                  </p>
                </div>
                <div className="whitespace-nowrap ml-4 md:ml-0">
                  <p className="text-center text-[#f0c259] whitespace-nowrap border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    Time
                  </p>
                  <p className="text-center whitespace-nowrap border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] rounded-lg font-semibold p-1 mt-2 px-4">
                    1970-01-01 00:00:00 UTC
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Recent Income end */}
        </div>
      )}

      {tabs === 1 && (
        <div className="h-screen">
          <div className="w-full flex justify-center p-4">
            <div className="mt-4 md:w-3/4 w-full">
              <div className="overflow-x-scroll w-full rounded-lg dark:text-white text-gray-800">
                <table className="w-full whitespace-nowrap">
                  <thead className="bg-[#8080821a]">
                    <th className="text-center text-white font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      SNo.
                    </th>
                    <th className="text-center text-white font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      ID
                    </th>
                    <th className="text-center text-white font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      Address
                    </th>
                    <th className="text-center text-white font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      Activation Date
                    </th>
                    <th className="text-center text-white font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      Level
                    </th>
                    <th className="text-center text-white font-bold py-3 px-2 border-2 border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                      Direct Team
                    </th>
                  </thead>
                  <tbody>
                    {referralData &&
                      referralData.map((data, index) => (
                        <tr key={index}>
                          <td className="text-center justify-center border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] py-3 px-2">
                            {index + 1}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {parseInt(data.id._hex, 16)}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {data.account}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {formatDate(data.start)}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {parseInt(data.level._hex, 16)}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {parseInt(data.directTeam._hex, 16)}
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      )}

      {tabs === 2 && (
        <div className="flex flex-col items-center mt-2 w-full p-4 overflow-x-auto min-h-screen">
          <h1 className="text-lime-500 font-bold text-2xl">Community</h1>
          <div className="text-teal-500 font-bold flex justify-center items-center">
            <input
              maxlength="7"
              className="p-2 px-4 mt-2 bg-gray-700 bg-opacity-45 w-[100px]"
              placeholder="ID"
              value="0"
            />
            <span className="py-2 mt-2 px-2 bg-green-500 h-full ml-2 text-white cursor-pointer p-2 rounded-sm text-sm font-medium">
              Search
            </span>
          </div>
          <div className="flex mt-4 flex-col justify-center items-center">
            <div className="flex flex-col justify-center items-center cursor-pointer">
              <img src="/bnb.png" className="h-12" />
              <h1 className="text-teal-500 font-semibold text-xs mt-1">0</h1>
            </div>
            <div className="border-2 mt-1 w-0 border-blue-500 h-16"></div>
          </div>
          <div className="flex relative justify-between w-2/3 md:w-1/2 border-t-0 border-blue-500 rounded-xl">
            <div className="flex flex-col justify-center items-center">
              <div className="border-2 w-0 border-blue-500 h-16"></div>
              <div className="flex flex-col items-center cursor-pointer">
                <img src="/restrict.png" className="h-14" />
                <h1 className="text-red-500 font-semibold text-xs">(None)</h1>
                <span className="py-1 mt-2 px-2 bg-green-500 rounded-sm text-sm font-medium">
                  Vacant
                </span>
              </div>
              <div className="border-2 mt-1 w-0 border-blue-500 h-16"></div>
            </div>
            <div className="absolute top-0 right-[33px] left-[33px] border-t-4 border-blue-500"></div>
            <div className="flex flex-col justify-center items-center">
              <div className="border-2 w-0 border-blue-500 h-16"></div>
              <div className="flex flex-col items-center cursor-pointer">
                <img src="/restrict.png" className="h-14" />
                <h1 className="text-red-500 font-semibold text-xs">(None)</h1>
                <span className="py-1 mt-2 px-2 bg-green-500 rounded-sm text-sm font-medium">
                  Vacant
                </span>
              </div>
              <div className="border-2 mt-1 w-0 border-blue-500 h-16"></div>
            </div>
          </div>
          <div className="w-[76%] border-t-4 border-blue-500"></div>
          <div className="flex justify-between w-full">
            <div className="flex flex-col justify-between w-1/4 items-center">
              <div className="flex flex-col items-center w-full cursor-pointer">
                <div className="border-2 w-0 border-blue-500 h-16"></div>
                <div className="flex flex-col items-center cursor-pointer">
                  <img src="/restrict.png" className="h-14" />
                  <h1 className="text-red-500 font-semibold text-xs">(None)</h1>
                  <span className="py-1 mt-2 px-2 bg-green-500 rounded-sm text-sm font-medium">
                    Vacant
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-center w-1/4 items-center">
              <div className="flex flex-col items-center w-full cursor-pointer">
                <div className="border-2 w-0 border-blue-500 h-16"></div>
                <div className="flex flex-col items-center cursor-pointer">
                  <img src="/restrict.png" className="h-14" />
                  <h1 className="text-red-500 font-semibold text-xs">(None)</h1>
                  <span className="py-1 mt-2 px-2 bg-green-500 rounded-sm text-sm font-medium">
                    Vacant
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-center w-1/4 items-center">
              <div className="flex flex-col items-center w-full cursor-pointer">
                <div className="border-2 w-0 border-blue-500 h-16"></div>
                <div className="flex flex-col items-center cursor-pointer">
                  <img src="/restrict.png" className="h-14" />
                  <h1 className="text-red-500 font-semibold text-xs">(None)</h1>
                  <span className="py-1 mt-2 px-2 bg-green-500 rounded-sm text-sm font-medium">
                    Vacant
                  </span>
                </div>
              </div>
            </div>
            <div className="flex flex-col justify-center w-1/4 items-center">
              <div className="flex flex-col items-center w-full cursor-pointer">
                <div className="border-2 w-0 border-blue-500 h-16"></div>
                <div className="flex flex-col items-center cursor-pointer">
                  <img src="/restrict.png" className="h-14" />
                  <h1 className="text-red-500 font-semibold text-xs">(None)</h1>
                  <span className="py-1 mt-2 px-2 bg-green-500 rounded-sm text-sm font-medium">
                    Vacant
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {tabs === 3 && (
        <>
          <div className="h-screen">
            <div className="w-full flex justify-center p-4">
              <div className="mt-4 md:w-3/4 w-full">
                <div className="flex overflow-x-auto">
                  {[...Array(12)].map((_, index) => (
                    <p
                      key={index}
                      className={`cursor-pointer font-medium px-4 py-2 rounded-sm ml-2 ${
                        selectedNumber === index + 1
                          ? "bg-blue-500"
                          : "bg-gray-700 bg-opacity-45"
                      }`}
                      onClick={() => setSelectedNumber(index + 1)}
                    >
                      {index + 1}
                    </p>
                  ))}
                </div>
                <div className="overflow-x-scroll mt-4 w-full rounded-lg dark:text-white text-gray-800">
                  <table className="w-full whitespace-nowrap ">
                    <thead className="bg-[#8080821a] ">
                      <tr>
                        <th className="text-center font-bold py-3 px-2 border-2 text-white border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                          SNo.
                        </th>
                        <th className="text-center font-bold py-3 px-2 border-2 text-white border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                          ID
                        </th>
                        <th className="text-center font-bold py-3 px-2 border-2 text-white border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                          Address
                        </th>
                        <th className="text-center font-bold py-3 px-2 border-2 text-white border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                          Sponsor ID
                        </th>
                        <th className="text-center font-bold py-3 px-2 border-2 text-white border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                          Activation Date
                        </th>
                        <th className="text-center font-bold py-3 px-2 border-2 text-white border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                          Level
                        </th>
                        <th className="text-center font-bold py-3 px-2 border-2 text-white border-[rgba(124,240,89,0.16)] bg-[rgba(124,240,89,0.14)]">
                          Direct Team
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {matrixData.map((item, index) => (
                        <tr key={index}>
                          <td className="text-center border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)] py-3 px-2">
                            {index + 1}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {item.id}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {item.address}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {item.sponsorId}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {item.activationDate}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {item.level}
                          </td>
                          <td className="text-center py-3 px-2 border-2 border-[rgba(240,194,89,.16)] text-white bg-[rgba(240,194,89,.14)]">
                            {item.directTeam}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Dashboard;
